export default __webpack_public_path__ + "static/warrior_1-f47616203189e50b0a120b8338c35726.jpg";